<template>
  <div v-if="start">
    <div v-if="!currentChannel">
      <p>Такой группы не существует</p>
    </div>
    <div v-else class="lg:w-3/4">
    <vx-card class="lg:p-8 w-full mb-6">
      <div v-if="currentChannel" class="mb-10">
        <router-link
          :to="{name: 'channels_edit', params: {channelSlug: currentChannel.slug}}">
          <vs-icon
            icon-pack="feather"
            icon="icon-arrow-left"
          />
          Вернуться назад
        </router-link>
      </div>
      <div class="vx-card__title mb-4">
        <h4 class="mb-4">Добавление мессенджера в канал</h4>
        <p>Описание настроек...</p>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-6">
          <vs-input
            class="w-full"
            label="Телефон: *"
            v-validate="'required'"
            name="phone"
            v-model="settings.phone"
            v-mask="'7##########'"
            placeholder="79999999999"
          />
          <span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-6">
          <vs-input
            class="w-full"
            label="Токен chat-api: *"
            v-validate="'required'"
            name="token"
            v-model="settings.token"
          />
          <span class="text-danger text-sm" v-show="errors.has('token')">{{ errors.first('token') }}</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-6">
          <vs-input
            class="w-full"
            label="Url chat-api: *"
            v-validate="{required: true, url: {require_protocol: true }}"
            name="api_url"
            v-model="settings.api_url"
          />
          <span class="text-danger text-sm" v-show="errors.has('api_url')">{{ errors.first('api_url') }}</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-6">
          <vs-input
            class="w-full"
            label="Начальный текст:"
            name="initial_message"
            v-validate="'required'"
            v-model="settings.initial_message"
          />
          <span class="text-danger text-sm" v-show="errors.has('initial_message')">{{ errors.first('initial_message') }}</span>
        </div>
      </div>
      <div class="flex justify-end">
        <vs-button
          ref="loadableButton"
          id="button-with-loading"
          class="vs-con-loading__container"
          @click.prevent="submitConnect">
          Подключить
        </vs-button>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/2 mb-6">
          <div class="flex items-center">
            <div class="mr-4">Возможность написать новому клиенту</div>
            <vs-switch
              v-model="settings.chat_first_enabled"
            />
          </div>
        </div>
      </div>
      <div class="vx-row" v-if="settings.chat_first_enabled">
        <div class="vx-col w-full lg:w-1/2 mb-6">
          <p>Лимит на исходящие обращения (в день): {{ settings.chat_first_daily_limit }}</p>
          <vs-slider
            ticks
            step="1"
            :min="1"
            :max="100"
            v-model="settings.chat_first_daily_limit"
            name="chat_first_daily_limit"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('chat_first_daily_limit')">{{ errors.first('chat_first_daily_limit') }}</span>
        </div>
      </div>
    </vx-card>
  </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import Channels from '../../api/http/models/channels/Channels'
import WAChat from '../../api/http/models/wachat/WAChat'
import errorsParsing from '../../mixins/errorsParsing'
import { copyObject} from '../../helpers/helpers'
import TransportPayloadCast from '../../api/http/models/wachat/WAChatPayloadCast'

export default {
  data () {
    return {
      start: false,
      currentChannel: null,
      settings: {
        ...copyObject(TransportPayloadCast)
      }
    }
  },
  computed: mapGetters(['authUserCompany']),
  mixins: [errorsParsing],
  async created () {
    const response = await Channels.getOne(this.authUserCompany.slug, this.$route.params.channelSlug)
    this.currentChannel = response.data || null
    this.start = true
  },
  methods: {
    async submitConnect () {
      const validate = await this.$validator.validateAll()

      if (validate) {
        const response = await WAChat.create(this.authUserCompany.slug, this.currentChannel.slug, this.settings)

        if (response.status === 'success') {
          this.$router.push({name: 'channels_edit', params: {channelSlug: this.currentChannel.slug}})
        } else if (response.status === 'already_exists') {
          this.$vs.notify({
            color: 'warning',
            title: 'WhatsApp чат уже был создан',
            text: ''
          })
        } else if (response.errors) {
          this.errorsParsing(response.errors)
        }
      }
    }
  }
}
</script>
